import React from "react";
import { useTranslation } from "react-i18next";
import { VOTE_STATIC_PATH_V2 } from "@/api/staticPaths";
import { canv } from "@/canv/global";
import style from "../VoteWindow.module.css";

export function EmptyBoardInfo() {
    const { t } = useTranslation();
    return (
        <div className={style.voteWindowEmpty}>
            <p className={style.voteWindowEmptyTitle}>{t("vote.emptyTitle")}</p>
            <img
                src={`${canv.host}${VOTE_STATIC_PATH_V2}canNotStartVoting.png`}
                alt="illustration"
            />
            <p className={style.voteWindowEmptyText}>{t("vote.emptyText")}</p>
            <ul className={style.voteWindowEmptyList}>
                <li>{t("vote.emptySticker")}</li>
                <li>{t("vote.emptyShape")}</li>
                <li>{t("vote.emptyImage")}</li>
                <li>{t("vote.emptyTextItem")}</li>
                <li>{t("vote.emptyCard")}</li>
            </ul>
        </div>
    );
}
